import reducerRegistry from 'reduxUtils/reducerRegistry';

const reducerName = 'loadableManager';
const createActionName = name => `toi/${reducerName}/${name}`;

export const GET_SCROLL_LOADABLE_STATUS = createActionName(
  'GET_SCROLL_LOADABLE_STATUS',
);
export const GET_CLICK_LOADABLE_STATUS = createActionName(
  'GET_CLICK_LOADABLE_STATUS',
);
export const GET_ON_LOAD_LOADABLE_STATUS = createActionName(
  'GET_ON_LOAD_LOADABLE_STATUS',
);
export const SET_LOADABLE_COMPONENT = createActionName(
  'SET_LOADABLE_COMPONENT',
);
export const SET_REQUESTIDLE_CALLBACK_COMPONENT_STATUS = createActionName(
  'SET_REQUESTIDLE_CALLBACK_COMPONENT_STATUS',
);

function receiveLoadableStatus(data) {
  return {
    type: GET_SCROLL_LOADABLE_STATUS,
    payload: data,
  };
}

function receiveClickLoadableStatus(data) {
  return {
    type: GET_CLICK_LOADABLE_STATUS,
    payload: data,
  };
}

function setLoadbaleComponent(data) {
  return {
    type: SET_LOADABLE_COMPONENT,
    payload: data,
  };
}

function setRequestIdleCallBackStatus(data) {
  return {
    type: SET_REQUESTIDLE_CALLBACK_COMPONENT_STATUS,
    payload: data,
  };
}

export function addLoadableComponent(component) {
  return dispatch => {
    dispatch(setLoadbaleComponent(component));
  };
}

export function updateRequestIdleCallBackStatus(data) {
  return dispatch => {
    dispatch(setRequestIdleCallBackStatus(data));
  };
}

export function updateLoadableStatus() {
  return dispatch => {
    if (typeof window !== 'undefined' && window.addEventListener) {
      window.addEventListener('scroll', function setLoadableEvent() {
        dispatch(receiveLoadableStatus(true));
        this.window.removeEventListener('scroll', setLoadableEvent);
      });

      window.addEventListener('click', function setClickLoadableEvent() {
        dispatch(receiveClickLoadableStatus(true));
        this.window.removeEventListener('click', setClickLoadableEvent);
      });

      // if (typeof document !== 'undefined') {
      //   if (document.readyState === 'complete') {
      //     // If document already loaded
      //     dispatch(receiveOnLoadLoadableStatus(true));
      //   } else if (document.addEventListener) {
      //     // If document is not yet loaded
      //     document.addEventListener('readystatechange', () => {
      //       if (document.readyState === 'complete') {
      //         setTimeout(() => {
      //           dispatch(receiveOnLoadLoadableStatus(true));
      //         }, 3000);
      //       }
      //     });
      //   } else {
      //     setTimeout(() => {
      //       dispatch(receiveOnLoadLoadableStatus(true));
      //     }, 3000);
      //   }
      // } else {
      //   setTimeout(() => {
      //     dispatch(receiveOnLoadLoadableStatus(true));
      //   }, 3000);
      // }
    }
  };
}

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case GET_SCROLL_LOADABLE_STATUS:
      return {
        ...state,
        loadLoadableOnScroll: action.payload,
      };
    case GET_CLICK_LOADABLE_STATUS:
      return {
        ...state,
        loadLoadableOnClick: action.payload,
      };
    case GET_ON_LOAD_LOADABLE_STATUS:
      return {
        ...state,
        loadLoadableOnLoad: action.payload,
      };
    case SET_LOADABLE_COMPONENT:
      return {
        ...state,
        loadableComponents: { ...state.loadableComponents, ...action.payload },
      };
    case SET_REQUESTIDLE_CALLBACK_COMPONENT_STATUS:
      return {
        ...state,
        requestIdleCallbackStatus: {
          ...state.requestIdleCallbackStatus,
          ...action.payload,
        },
      };
    default:
      return {
        ...state,
      };
  }
}

reducerRegistry.register(reducerName, reducer);
